import axiosClient from '../axiosClient';

const clearedDaysService = {
  async fetchAll(filters = {}) {
    const response = await axiosClient.get('/cleared-days', {
      params: filters,
    });
    return response.data;
  },

  async export(filters = {}) {
    const response = await axiosClient.get('/cleared-days/export', {
      params: filters,
      responseType: 'blob',
    });
    return response;
  },
};

export default clearedDaysService;
